import { Types } from '../../ducks/asyncQuotation';
import { emailSubmitSagaAction } from './emailSubmitSagaAction';

export default {
  [Types.EMAIL_SUBMIT_SAGA_ACTION]: emailSubmitSagaAction,
};
